import { DocumentType } from "../constants/DocumentUpload";
import { IconFaFile, IconFaRegFileImage, IconFaRegFilePdf, IconFaRegFileWord } from "../styles/common/style";

export const getDocTypeIcon = (type: DocumentType) => {
  switch (type) {
    case DocumentType.INVALID:
      return <IconFaFile />;
    case DocumentType.DOC:
    case DocumentType.DOCX:
      return <IconFaRegFileWord />;
    case DocumentType.PDF:
      return <IconFaRegFilePdf />;
    case DocumentType.JPEG:
    case DocumentType.PNG:
    case DocumentType.JPG:
      return <IconFaRegFileImage />;
  }
  return <IconFaFile />;
};
